// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "bd8f141c97bb9fade3a4" + ".chunk.js";
};